import { updateAlignment, updateAngle, updateCharSpacing, updateLineHeight } from '@/infrastructure/engine2d/text/textMutations';
import type { TTextLayoutPatch } from '@/domain/textbox/TTextLayoutPatch';
import type { TTextLayoutResult } from '@/domain/textbox/TTextLayoutResult';
import type { IFabricTextCustom } from '@/infrastructure/engine2d/types/IFabricTextCustom';
import type { ITextboxCustom } from '@/infrastructure/engine2d/types/ITextboxCustom';
import type { Canvas } from 'fabric';

type TApplyTextLayoutParams = {
    fabricCanvas: Canvas;
    fText: IFabricTextCustom & ITextboxCustom;
    patch: TTextLayoutPatch;
};

function applyTextLayoutToFabric(params: TApplyTextLayoutParams): TTextLayoutResult {
    const { fabricCanvas, fText, patch } = params;
    const result: TTextLayoutResult = {};

    if (patch.align !== undefined) {
        updateAlignment(fabricCanvas, fText, patch.align);
    }
    if (patch.angleDeg !== undefined) {
        updateAngle(fabricCanvas, fText, patch.angleDeg);
        result.angleDeg = fText.angle;
        result.position = { x: fText.left, y: fText.top };
    }
    if (patch.lineHeight !== undefined) {
        updateLineHeight(fabricCanvas, fText, patch.lineHeight);
    }
    if (patch.charSpacing !== undefined) {
        updateCharSpacing(fabricCanvas, fText, patch.charSpacing);
    }

    return result;
}

export { applyTextLayoutToFabric };
